import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserService } from './core/user/user.service';
import { AuthService } from './core/auth/auth.service';
import { onBoardingService } from './modules/landing/onBoarding/onBoarding.service';
import { RouteGuardGuard } from './modules/landing/onBoarding/route-guard.guard';
import { catchError, timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit{
    /**
     * Constructor
     */
    constructor(
        private _userService: UserService,
        private _authService: AuthService,
        private _onBoardingService: onBoardingService,
        private _routeGuard: RouteGuardGuard,
        private _fuseSplashScreenService: FuseSplashScreenService
    ) {}
    
    ngOnInit(): void {
        // Garantizar que la pantalla de carga desaparezca después de un máximo de 5 segundos
        // independientemente de qué ocurra con las APIs
        setTimeout(() => {
            this._fuseSplashScreenService.hide();
        }, 5000);
        
        try {
            // Restaurar información de autenticación si existe
            const token = localStorage.getItem('onboardingAccessToken');        
            if (token) {
                // Si el token existe, el usuario está autenticado
                this._authService._authenticated = true;
                try {
                    const user = JSON.parse(localStorage.getItem('user') || '{}');
                    if (user && user.email) {
                        this._userService.user = user; 
                        this._onBoardingService.List()
                        .pipe(
                            timeout(3000), // 3 segundos timeout
                            catchError(error => {
                                console.error('Error cargando datos de onboarding:', error);
                                // En caso de error, inicializar con paso 1 por defecto
                                this._routeGuard.initializeStepFromApiData(1);
                                return of(null);
                            })
                        )
                        .subscribe(
                            (response) => {
                                if (response) {
                                    this._routeGuard.initializeStepFromApiData(response.currentStep);
                                } else {
                                    // Si la respuesta es nula (debido a un error), usar paso 1
                                    this._routeGuard.initializeStepFromApiData(1);
                                }
                            }
                        );
                    }
                } catch (e) {
                    console.error('Error al parsear datos de usuario:', e);
                }
            }
            
            // Intentar cargar datos de onboarding con timeout y manejo de errores
            
        } catch (e) {
            console.error('Error en la inicialización de AppComponent:', e);
            // Asegurar que incluso en caso de error se muestre la UI
            this._routeGuard.initializeStepFromApiData(1);
        }
    }
}
